import header from '../modules/header';
import initAnalyzer from '../modules/initAnalyzer';

jQuery(function() {
    header();
    initAnalyzer();
})
